import styled from '@emotion/styled';
import { media } from '../../../utils/stylesVariables';
import { keyframes } from '@emotion/react';

interface BackdropProps {
    showModal: boolean;
    whiteBackdrop: boolean;
}

export const Backdrop = styled.div<BackdropProps>`
    width: 100%;
    height: 100vh !important;
    position: fixed;
    z-index: 100;
    left: 0;
    top: 0;
    ${props => props.showModal && 'background-color: rgba(45, 54, 67, 0.5)'};
    ${props => !props.showModal && 'visibility: hidden'};
    transition: all 0.4s ease-in 0s;
    opacity: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    ${props => (props.whiteBackdrop ? 'background-color: white;' : '')}
`;

const openModal = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1; 
  }
`;

const closeModal = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0; 
  }
`;

interface ModalWrapperProps {
    showModal: boolean;
    width: number | string;
    height: number | string;
}

export const ModalWrapper = styled.div<ModalWrapperProps>`
    z-index: 500;
    background-color: white;
    box-sizing: border-box;
    animation: ${props => (props.showModal ? openModal : closeModal)} 400ms ease-in forwards;
    display: flex;
    justify-content: center;
    box-shadow: 0px 0px 10px #000000;
    align-items: center;
    position: absolute;
    ${media.mobileLandscape} {
        width: 540px;
    }
    ${props => (props.width ? `width: ${props.width};` : '')}
    ${props => (props.height ? `height: ${props.height};` : '')}
`;
